import { Modal, Form, Input, Message } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'
import { bindWeChatApi } from '@/api/user'
import { getFormValidateErrorMessage } from '@/utils/helpers'

interface WeChatBindModalProps {
  visible: boolean
  onClose: () => void
  onSuccess: () => Promise<void>
}

export default function WeChatBindModal({ visible, onClose, onSuccess }: WeChatBindModalProps) {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const submit = async () => {
    try {
      const values = await form.validate()
      await bindWeChatApi(values.code)
      Message.success(t('personal.wechatModal.success'))
      onClose()
      await onSuccess()
    } catch (err: unknown) {
      Message.error(getFormValidateErrorMessage(err))
    }
  }

  return (
    <Modal
      title={t('personal.wechatModal.title')}
      visible={visible}
      onCancel={onClose}
      onOk={() => void submit()}
      unmountOnExit
    >
      <Form form={form} layout="vertical">
        <Form.Item field="code" label={t('personal.wechatModal.code')} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}
